export const FOMO_ELEMENTS = {
    VIEWED: "VIEWED",
    PRICE_DROP: "PRICE_DROP",
    WISHLISTED: "WISHLISTED"
};
